var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartupsIconMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.4038 30.9474C62.4038 48.0372 48.5462 61.8947 31.4564 61.8947C14.3666 61.8947 0.509033 48.0372 0.509033 30.9474C0.509033 13.8576 14.3666 0 31.4564 0C48.5462 0 62.4038 13.8576 62.4038 30.9474Z",
    fill: "#151514"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8167 33.4214L23.3412 32.8997C22.8197 38.9132 25.7482 42.3986 31.634 42.3986C35.3591 42.3986 39.6459 40.9942 39.6459 37.1476C39.6459 33.8628 36.7231 33.4615 31.6741 32.1774C25.2611 30.5322 21.6964 29.0531 21.6964 24.2435C21.6964 20.0358 24.3785 16.3096 31.634 16.3096C39.2447 16.3096 42.6547 20.437 42.6547 26.5709L39.1301 27.0525C39.1702 21.6409 36.5683 19.5198 31.5996 19.5198C26.6308 19.5198 25.0261 21.6868 25.0261 24.0486C25.0261 26.1696 26.2698 27.3735 32.7572 28.8181C39.2906 30.3029 43.0157 32.1029 43.0157 37.1132C43.0157 42.605 38.4882 45.6089 31.9148 45.6089C23.3011 45.6089 19.4556 40.398 19.8167 33.4271",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartupsIconMedium);
export default __webpack_public_path__ + "static/media/startupsIconMedium.dc994038.svg";
export { ForwardRef as ReactComponent };var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartupsIconMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.4038 30.9474C62.4038 48.0372 48.5462 61.8947 31.4564 61.8947C14.3666 61.8947 0.509033 48.0372 0.509033 30.9474C0.509033 13.8576 14.3666 0 31.4564 0C48.5462 0 62.4038 13.8576 62.4038 30.9474Z",
    fill: "#151514"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8167 33.4214L23.3412 32.8997C22.8197 38.9132 25.7482 42.3986 31.634 42.3986C35.3591 42.3986 39.6459 40.9942 39.6459 37.1476C39.6459 33.8628 36.7231 33.4615 31.6741 32.1774C25.2611 30.5322 21.6964 29.0531 21.6964 24.2435C21.6964 20.0358 24.3785 16.3096 31.634 16.3096C39.2447 16.3096 42.6547 20.437 42.6547 26.5709L39.1301 27.0525C39.1702 21.6409 36.5683 19.5198 31.5996 19.5198C26.6308 19.5198 25.0261 21.6868 25.0261 24.0486C25.0261 26.1696 26.2698 27.3735 32.7572 28.8181C39.2906 30.3029 43.0157 32.1029 43.0157 37.1132C43.0157 42.605 38.4882 45.6089 31.9148 45.6089C23.3011 45.6089 19.4556 40.398 19.8167 33.4271",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartupsIconMedium);
export default __webpack_public_path__ + "static/media/startupsIconMedium.dc994038.svg";
export { ForwardRef as ReactComponent };